export default function Impressum() {
    return(
        <div>
            <h2 className="mb-5 mt-5 section-heading">Impressum</h2>
            <h3 className="justify-content-center">Verantwortlich für den Inhalt</h3>
            <p className="justify-content-center">Reifenservice und Anhängerverleih<br/>Horst Schönbeck<br/>Ramsdorf
                33<br/>94574 Wallerfing</p>
        </div>
    );
}